import type { ThemeOptions } from '@mui/material';
import oldcastleLogo from '../../assets/brandings/oldcastle/oldcastleLogo.svg';
import oldcastleNavbarLogo from '../../assets/brandings/oldcastle/oldcastleNavbarLogo.svg';

export const oldcastleTheme: ThemeOptions = {
  assets: {
    logoURL: oldcastleLogo,
    navbarLogoURL: oldcastleNavbarLogo,
  },
  palette: {
    primary: { main: '#041e42' },
    secondary: { main: '#041e42' },
    background: {
      default: '#fff',
      paper: '#fff',
    },
    rainfall: { main: '#78be20' },
    appBarBackground: {
      main: '#041e42',
      light: '#041e42',
      dark: '#041e42',
      contrastText: '#041e42',
    },
    appBarText: { main: '#fff' },
  },
};
